import React, { Component, PropTypes } from 'react'
import './Home.scss'
import HomeNav from './HomeNav'
import HomeBanner from './HomeBanner'
import HomeAppDescription from './HomeAppDescription'
import HomeFeatures from './HomeFeatures'
import HomeVideo from './HomeVideo'
import HomeFooter from './HomeFooter'
import HomeGetInTouch from './HomeGetInTouch'
import HomeOurTeam from './HomeOurTeam'
import HomePricing from './HomePricing'
import HomeQuotes from './HomeQuotes'
import HomeScreenshots from './HomeScreenshots'
import HomeSignUpBanner from './HomeSignUpBanner'
import HomeUSPs from './HomeUSPs'

import { firebaseApp } from '../../../config';

export class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {

        return (
            <div className='homepage'>


              <HomeNav
                links={[
                  {label: 'Home', section: 'home'},
                  {label: 'About', section: 'about'},
                  {label: 'Features', section: 'features'},
                  {label: 'Screenshots', section: 'screenshots'},
                  {label: 'Pricing', section: 'pricing'},
                  {label: 'Testimonials', section: 'testimonials'},
                  {label: 'Team', section: 'team'},
                  {label: 'Contact', section: 'contact'}
                ]}
               />

               <HomeBanner
                 title='Pro Quotes'
                 description='A complete business management tool to save you time & money'
                 cta='Get Started'
                 location={this.props.location.pathname}
                 notify={this.props.notify}
               />


               <HomeUSPs
                 title="Why it's Special"
                 points={[
                   {title: 'Simple to Use', icon: 'icon-trending-up', description: 'We felt like no business management app emphasized one of the most essential principles: ease of use. Pro Quotes is simple and effective.'},
                   {title: '4 Steps to Success', icon: 'icon-trending-up', description: 'Manage your jobs by quotes, confirmed, invoiced and Paid with complete visibility over your cashflow. Anywhere, anytime, on any device.'},
                   {title: 'Easy Tax Returns', icon: 'icon-trending-up', description: 'Total control over your work calendar, cashflow & tax return. Stress free business management for any trade, anywhere.'}
                 ]}
               />


               <HomeAppDescription
                 title='Professional Quotes & Invoices - Anywhere'
                 description="Easily create your quotes & invoices to send to your customers. You'll be happier, faster and more focused. What are you waiting for?"
                />




                <HomeFeatures
                  title='Incredible Features'
                  features={[
                    {title: 'Powerful Reporting', icon: 'icon-trending-up', description: "Stay focused of whats important, your customers. Pro Quotes makes your entire cashflow visible and your tax returns a breeze."},
                    {title: 'Lightning Fast', icon: 'icon-trending-up', description: "Your time is important and our technology is quick. Your reports will instantly be calculated whenever you make a change."},
                    {title: 'Real Time Technology', icon: 'icon-trending-up', description: "Need to update your quote or invoice? No worries, everything you change is real-time. Customers see what you see, the moment it is updated."},
                    {title: 'Secure & Maintained', icon: 'icon-trending-up', description: "Built upon Google Technology for complete reassurance that your data is safe. We never share with third parties or sell your data."},
                    {title: "Live Work Calendar", icon: 'icon-trending-up', description: "Your schedule is automatially generated when quotes are created to make life simple. Business money & scheduling has never been easier."},
                    {title: "Feel Empowered Again", icon: 'icon-trending-up', description: "We designed our interface with you in mind, everything is snappy and looks just perfect. Straight to the point and easy to digest."}
                  ]}
                 />

                 <HomeVideo
                   src='/assets/app-screen.png'
                 />

                 <HomeScreenshots
                   title='Screenshots'
                   screenshots={[
                     {url: '/assets/home-img/scr-img/app-3.jpg'},
                     {url: '/assets/home-img/scr-img/app-2.jpg'},
                     {url: '/assets/home-img/scr-img/app-1.jpg'},
                     {url: '/assets/home-img/scr-img/app-4.jpg'},
                     {url: '/assets/home-img/scr-img/app-5.jpg'}
                   ]}
                 />

                  <HomeSignUpBanner
                    title='100% Money Back Guarantee'
                    description='Pro Quotes Will Save You Time & Money and if you dont think so, we will refund you. Simple.'
                    cta='Get Started'
                  />

                  <HomeOurTeam
                    title='Our Team'
                    employees={[
                      {name: 'David Allard', role: 'Chief Technology Officer (CTO)', pic: 'http://placehold.it/100x100'},
                      {name: 'Paul Gillham', role: 'Business Development Manager', pic: 'http://placehold.it/100x100'},
                    ]}
                   />

                   <HomeFooter
                     links={[
                       {label: 'About', url: 'about'},
                       {label: 'Terms & Conditions', url: 'terms-conditions'},
                       {label: 'Privacy Policy', url: 'privacy'},
                       {label: 'Contact', url: 'contact'}
                     ]}
                     social={[
                       {label: 'Facebook', url: 'about'},
                       {label: 'Twitter', url: 'terms-conditions'}
                     ]}
                     strapline='@ ProQuotes 2018 - all rights reserved'
                    />

            </div>

        )

    }
}

// <HomeQuotes
//   quotes={[
//     {name: 'Henry Smith', role: 'Trader', pic: 'http://placehold.it/100x100', quote: 'I use Colorlib for usability testing. Its great for taking images and making clickable image prototypes that do the job and save me the coding time and just the general hassle of hosting.'},
//     {name: 'Henry Smith', role: 'Trader', pic: 'http://placehold.it/100x100', quote: 'I use Colorlib for usability testing. Its great for taking images and making clickable image prototypes that do the job and save me the coding time and just the general hassle of hosting.'},
//     {name: 'Henry Smith', role: 'Trader', pic: 'http://placehold.it/100x100', quote: 'I use Colorlib for usability testing. Its great for taking images and making clickable image prototypes that do the job and save me the coding time and just the general hassle of hosting.'}
//   ]}
//  />

// <HomeGetInTouch
//    title='Get in touch with us!'
//    description='Find the perfect plan for you — 100% satisfaction guaranteed.'
//    address='40 Baria Sreet 133/2 NewYork City, US'
//    phone='+11-225-888-888-66'
//    email='info.deercreative@gmail.com'
// />

// <div className='hidden'><HomePricing /></div>

export default Home



// WEBPACK FOOTER //
// ./src/views/pages/Home2/index.js